import { SlidingPanel } from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { MessageSquare } from "lucide-react";
import { arrayOf, func, number, object, oneOf, shape } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { fetchCounts, postBulkComment } from "slices/comments";

import classes from "./BulkCommentPanel.module.scss";
import CommentComposer from "./CommentComposer";

const SURFACES = [
  "SHRED_PARAGRAPH",
  "SHRED_SENTENCE",
  "ACRONYM_ENTRY",
  "COMPARE_RESULT",
  "OUTLINE_SECTION",
];

const BulkCommentPanel = ({
  surface,
  containerId,
  itemRefs,
  triggerRef,
  onClose,
}) => {
  const dispatch = useDispatch();
  const [body, setBody] = useState("");

  const handleClose = () => {
    onClose();
    triggerRef?.current?.focus();
  };

  const handleSubmit = async () => {
    await dispatch(
      postBulkComment({ surface, containerId, itemRefs, body })
    ).unwrap();
    dispatch(fetchCounts({ surface, containerId }));
    handleClose();
  };

  return (
    <SlidingPanel>
      <SlidingPanel.Header onHide={handleClose}>
        <Flex gap={GAP_CLASS.GAP_200}>
          <MessageSquare size={18} aria-hidden="true" />
          Comment on {itemRefs.length} Selected
        </Flex>
      </SlidingPanel.Header>
      <SlidingPanel.Body>
        <p className={classes["description"]}>
          This comment will be added to each of the {itemRefs.length} selected
          rows.
        </p>
      </SlidingPanel.Body>
      <SlidingPanel.Footer>
        <CommentComposer
          value={body}
          onChange={setBody}
          onSubmit={handleSubmit}
          placeholder="Add a comment to all selected rows…"
          submitLabel="Post"
        />
      </SlidingPanel.Footer>
    </SlidingPanel>
  );
};

BulkCommentPanel.propTypes = {
  surface: oneOf(SURFACES).isRequired,
  containerId: number.isRequired,
  itemRefs: arrayOf(object).isRequired,
  triggerRef: shape({ current: object }),
  onClose: func.isRequired,
};

export default BulkCommentPanel;
